$(document).ready(function(){
  if($('.product-item-bundle').length > 0){
    var $divProductBundle = $('.product-item-bundle');
    checkStatusBundle($divProductBundle);
    $('button.product-item-bundle-btn-add', $divProductBundle).on('click', function(){
      $(this).hide();
      var $divPQ = $(this).next('.product-item-bundle-quantity');
      $divPQ.css('display', 'flex');
      $('input[type=number]', $divPQ).attr('readonly', false);
      $('input[type=number]', $divPQ).val(1);
      $('input[type=number]', $divPQ).attr('readonly', true);
      $('input[type=number]', $divPQ).trigger('change');
    });
    $('input[type=number]', $divProductBundle).on('change', function(e){
      //console.log(e);
      if($(this).val() <= 0){
        $(this).parents('.product-item-bundle-description-qtt').find("button.product-item-bundle-btn-add").show();
        $(this).parents('.product-item-bundle-quantity').hide();
      }
      checkStatusBundle($divProductBundle);
    });
    $('button.product-item-bundle-quantity-increase').on("click", function(){
      var $input = $(this).prev('input');
      	$input.attr('readonly', false);
    	$input.val(parseInt($(this).prev('input').val())+1);
      	$input.attr('readonly', true);
      	$input.trigger('change');
    });
    $('button.product-item-bundle-quantity-decrease').on("click", function(){
      var $input = $(this).next('input');
      	$input.attr('readonly', false);
    	$input.val(parseInt($input.val())-1);
      	$input.attr('readonly', true);
      	$input.trigger('change');
    });
  }
  function checkStatusBundle($div){
    var txtMin = "Votre boîte doit contenir au moins {{nb_min}} produits.";
    txtMin = txtMin.replace("{{nb_min}}", $($div).data('mpimin'));
    var nbItems = 0;
    $('input[type=number]', $div).each(function(){
    	nbItems += parseInt($(this).val());
    });
    if(nbItems < $($div).data('mpimin')){
      //On affiche un message
      $('.add-to-cart .product-bundle-invalid').remove();
      $('.add-to-cart').prepend("<p class='product-bundle-invalid txt-error'>"+txtMin+"</p>");
      //On enable les increase button
      $('button.product-item-bundle-quantity-increase').attr('disabled', false);
      $('button.product-item-bundle-btn-add').attr('disabled', false);
      //on disable le add to cart form
      $('.add-to-cart input[type=submit]').attr('disabled', true);
      $('.add-to-cart button.shopify-payment-button__button').attr('disabled', true);
    }
    if(nbItems >= $($div).data('mpimax')){
      //on supprime le message
      $('.add-to-cart .product-bundle-invalid').remove();
      //on disable les increase button
      $('button.product-item-bundle-quantity-increase').attr('disabled', true);
      $('button.product-item-bundle-btn-add').attr('disabled', true);
      //on enable le add to cart form
      $('.add-to-cart input[type=submit]').attr('disabled', false);
      $('.add-to-cart button.shopify-payment-button__button').attr('disabled', false);
    }
  }
});